import { Badge } from "@mantine/core";
import { useTranslation } from "react-i18next";
import style from "./lastUsedBadge.module.css";

export const getLastSignInMethod = () => {
    try {
        const preference = localStorage.getItem("signInPreference");
        return ["google", "email", "phone"].includes(preference) ? preference : null;
    } catch (e) {
        // localStorage is unavailable in some privacy modes
        return null;
    }
};

const LastUsedBadge = ({children = null}) => {
    const { t } = useTranslation(["common"]);

    return (
        <div className={style.wrapper}>
            {children}

            <Badge className={style.lastUsedBadge} size="sm" variant="filled" color="indigo" radius={"lg"}>
                {t("auth.sign-in.form.last-used")}
            </Badge>
        </div>
    );
};

export default LastUsedBadge;
